export const API_BASE_URL = 'https://grocysmart.visssible.com/backend/';
